import type { AppIconProps } from "../IconTypes";

export const TableIcon: React.FC<AppIconProps> = ({
  width,
  height,
  className,
}) => {
  return (
    <svg
      className={className}
      width={width || "24"}
      height={height || "24"}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
    >
      <path
        d="M0 3C0 2.20435 0.316071 1.44129 0.87868 0.87868C1.44129 0.316071 2.20435 0 3 0L21 0C21.7956 0 22.5587 0.316071 23.1213 0.87868C23.6839 1.44129 24 2.20435 24 3V21C24 21.7956 23.6839 22.5587 23.1213 23.1213C22.5587 23.6839 21.7956 24 21 24H3C2.20435 24 1.44129 23.6839 0.87868 23.1213C0.316071 22.5587 0 21.7956 0 21V3ZM22.5 6H16.5V10.5H22.5V6ZM22.5 12H16.5V16.5H22.5V12ZM22.5 18H16.5V22.5H21C21.3978 22.5 21.7794 22.342 22.0607 22.0607C22.342 21.7794 22.5 21.3978 22.5 21V18ZM15 22.5V18H9V22.5H15ZM7.5 22.5V18H1.5V21C1.5 21.3978 1.65804 21.7794 1.93934 22.0607C2.22064 22.342 2.60218 22.5 3 22.5H7.5ZM1.5 16.5H7.5V12H1.5V16.5ZM1.5 10.5H7.5V6H1.5V10.5ZM9 6V10.5H15V6H9ZM15 12H9V16.5H15V12Z"
        fill="#1D9F81"
      />
    </svg>
  );
};
